import { render, staticRenderFns } from "./WidgetRenderer.vue?vue&type=template&id=18dd503f&scoped=true"
import script from "./WidgetRenderer.vue?vue&type=script&lang=js"
export * from "./WidgetRenderer.vue?vue&type=script&lang=js"
import style0 from "./WidgetRenderer.vue?vue&type=style&index=0&id=18dd503f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd503f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
